export default __webpack_public_path__ + "static/media/retro5.e092d5be.jpg";